export const DAY_NAMES = [
  "domingo",
  "lunes",
  "martes",
  "miércoles",
  "jueves",
  "viernes",
  "sábado",
];

export const DAY_ABBR = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];

export const MONTH_ABBR = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

export const MONTH_NAMES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

export function formatDate(date: string | null): string {
  if (!date) return "-";
  const [year, month, day] = date.split("-").map(Number);
  const weekday =
    DAY_NAMES[new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
  return `${weekday}, ${String(day).padStart(2, "0")} de ${MONTH_NAMES[month - 1]} de ${year}`;
}

/** "27-31 de mayo" within one month, "27 de mayo - 2 de junio" across months
 *  (year appended to each side when it differs). */
export function formatDateRange(
  start: string | null,
  end: string | null,
): string {
  if (!start) return "-";
  const [startYear, startMonth, startDay] = start.split("-").map(Number);
  const startLabel = `${startDay} de ${MONTH_NAMES[startMonth - 1]}`;
  if (!end || end === start) return startLabel;

  const [endYear, endMonth, endDay] = end.split("-").map(Number);
  if (startYear === endYear && startMonth === endMonth) {
    return `${startDay}-${endDay} de ${MONTH_NAMES[startMonth - 1]}`;
  }
  const endLabel = `${endDay} de ${MONTH_NAMES[endMonth - 1]}`;
  if (startYear === endYear) return `${startLabel} - ${endLabel}`;
  return `${startLabel} de ${startYear} - ${endLabel} de ${endYear}`;
}

export function formatTime(time: string | null): string {
  if (!time) return "-";
  const match = time.match(/T(\d{2}:\d{2})/);
  return match ? match[1] : time.slice(0, 5);
}

/** "Lun 09 Jul 09:30 - Mié 11 Jul 23:00" */
export function formatDateTimeRange(
  startDate: string | null,
  endDate: string | null,
  startTime: string | null,
  endTime: string | null,
): string {
  if (!startDate) return "-";
  const label = (date: string, time: string | null) => {
    const [year, month, day] = date.split("-").map(Number);
    const weekday =
      DAY_ABBR[new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
    return `${weekday} ${String(day).padStart(2, "0")} ${MONTH_ABBR[month - 1]} ${formatTime(time)}`;
  };
  return `${label(startDate, startTime)} - ${label(endDate ?? startDate, endTime)}`;
}

export function formatAmount(amount: number | null): string {
  if (amount == null) return "-";
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0,
  }).format(amount);
}
